import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import type { Coupon } from 'shared/src/api';
import { isNotNil } from 'shared/src/utils';

export const useLogClickCouponList = (
  coupon: Coupon | null,
  isExistUsableCoupons?: boolean,
) => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_COUPON_LIST',
      channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
      analytics: {
        IS_EXIST_USABLE_COUPONS: isExistUsableCoupons ? '1' : '0',
        IS_EXIST_DOWNLOADABLE_COUPONS: isNotNil(coupon) ? '1' : '0',
      },
    });
  }, [coupon, isExistUsableCoupons, logGoodsAnalytics]);
};
